import { useState } from "react";

export const INJURY_PRESETS = ["knee", "shoulder", "lower back", "hip", "wrist/elbow", "ankle", "neck"];

export const TagInput = ({ value = [], onChange, presets = INJURY_PRESETS, placeholder = "Add custom…", testId = "injury-tags" }) => {
  const [draft, setDraft] = useState("");
  const add = (t) => { const k = t.trim().toLowerCase(); if (k && !value.includes(k)) onChange([...value, k]); setDraft(""); };
  const remove = (t) => onChange(value.filter((x) => x !== t));
  return (
    <div data-testid={testId}>
      <div className="hl" style={{ marginBottom: 6 }}>
        {value.map((t) => <span className="injury" key={t} data-testid={`${testId}-tag-${t.replace(/[^a-z0-9]+/g, "-")}`}>{t}<button type="button" onClick={() => remove(t)} aria-label={`Remove ${t}`} data-testid={`${testId}-remove-${t.replace(/[^a-z0-9]+/g, "-")}`}>×</button></span>)}
        {value.length === 0 && <span className="ss">None</span>}
      </div>
      <div className="actions" style={{ flexWrap: "wrap", gap: 4 }}>
        {presets.filter((p) => !value.includes(p)).map((p) => <button type="button" key={p} className="btn sm g" onClick={() => add(p)} data-testid={`${testId}-preset-${p.replace(/[^a-z0-9]+/g, "-")}`}>+ {p}</button>)}
        <input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(draft); } }} onBlur={() => draft && add(draft)} placeholder={placeholder} style={{ width: 140, padding: "4px 10px", fontSize: 12 }} maxLength={30} data-testid={`${testId}-input`} />
      </div>
    </div>
  );
};
